import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ddt from '@wix/da-ddt';
import * as Cookie from 'js-cookie';
import { setCookieAccepted, setCookieSettings, } from '../../publicSession/actions';
/**
 * Nitro ads CMP
 *
 * https://docs.nitropay.com/en/articles/4603199-adding-custom-consents-disclosures-to-the-consent-management-platform
 */
export function useCmpInit(_a) {
    var adsEnabled = _a.adsEnabled;
    var NITRO_COOKIE = 'ncmp-cc';
    var dispatch = useDispatch();
    var checkConsent = function (cmpKey, cookieKey) {
        window['__tcfapi']('hasCustomConsent', 2, function (res) {
            var _a;
            if (res) {
                dispatch(setCookieSettings((_a = {}, _a[cookieKey] = true, _a)));
                ddt.log('ads', "CMP: ".concat(cmpKey, " opted in"));
            }
        }, cmpKey);
    };
    useEffect(function () {
        if (!adsEnabled || typeof window === 'undefined') {
            return;
        }
        if (typeof window['__tcfapi'] === 'undefined') {
            return;
        }
        var cmpCallback = function () {
            ddt.log('ads', 'CMP: useractioncomplete TO', Cookie.get(NITRO_COOKIE));
            checkConsent('da-analytics', 'analytics');
            checkConsent('da-functional', 'functional');
            checkConsent('da-marketing', 'marketing');
            // save consent settings
            dispatch(setCookieAccepted());
        };
        window['__tcfapi']('addEventListener', 2, function (tcData, success) {
            ddt.log('ads', 'CMP: useractioncomplete', tcData, Cookie.get(NITRO_COOKIE));
            if (success && tcData.eventStatus === 'useractioncomplete') {
                setTimeout(cmpCallback, 0); // Seems complete needs a delay before reading...
            }
        });
        // Also check the cookie, this might happen if user is fast and clicks the accept button
        // before react loads (as react boot is slow) so in this case we read the cookie and set
        // the cookie acceptance. Slight chance they could browse away but we need redux...
        var consentCookie = Cookie.get(NITRO_COOKIE);
        if (consentCookie &&
            /da-analytics|da-functional|da-marketing/.test(consentCookie)) {
            var consents = consentCookie.split(',');
            dispatch(setCookieSettings({
                analytics: consents.includes('da-analytics'),
                functional: consents.includes('da-functional'),
                marketing: consents.includes('da-marketing'),
            }));
            dispatch(setCookieAccepted());
        }
        // We only want this to run once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
//# sourceMappingURL=useCmpInit.js.map